export default {
  modalTitle: {
    id: 'product_jp_verified_sim_unlocked_modal_title',
    defaultMessage: 'SIM unlock',
  },
  modalSubTitle: {
    id: 'product_jp_verified_sim_unlocked_modal_sub_title',
    defaultMessage: 'SIM unlocked: Compatible with all carriers',
  },
  modalDescriptionPart1: {
    id: 'product_jp_verified_sim_unlocked_modal_description_part_1',
    defaultMessage:
      'SIM unlock means unlocking a device that was originally restricted to a specific carrier (e.g., docomo, au, SoftBank), allowing it to be used with SIM cards from other carriers. This includes compatibility with budget SIM cards and international SIM cards.',
  },
  modalDescriptionPart2: {
    id: 'product_jp_verified_sim_unlocked_modal_description_part_2',
    defaultMessage:
      'All products sold on Back Market come with the SIM lock removed.',
  },
  modalInfoBlockTitle: {
    id: 'product_jp_verified_sim_unlocked_modal_info_block_title',
    defaultMessage: 'Restrictions on Android devices',
  },
  modalInfoBlockContent: {
    id: 'product_jp_verified_sim_unlocked_modal_info_block_content',
    defaultMessage:
      'Android devices may support different bands (frequencies) depending on the model, which means 4G/5G connectivity may not be available or could be weaker with certain carriers. This can be particularly noticeable in rural areas, so we recommend checking the supported bands of your carrier before making a purchase',
  },
  modalInfoBlockReadMore: {
    id: 'product_jp_verified_sim_unlocked_modal_info_block_read_more',
    defaultMessage: 'Read more',
  },
  modalCta: {
    id: 'product_jp_verified_sim_unlocked_modal_cta',
    defaultMessage: 'More about SIM unlock',
  },
}
